import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';
import omitProps from '../../../utils/omitProps';


import queryMetaHandler from '../../../utils/queryMetaHandler';
import ExcelTicketSummary from '../../../components/ExcelTicketSummary';


export const DocumentQuery = gql`
  query Document($documentId: Int!) {
    document(id: $documentId) {
      id
      multipage
      fileCount: file_count
      uploadedFiles: uploaded_files {
        edges {
          node {
            id
            url: view_url
            contentType: content_type
            excelTicketSummary: excel_ticket_summary {
              ...Summary
            }
          }
        }
      }
    }
  }
  ${ExcelTicketSummary.fragment}
`;


const queryData = graphql(DocumentQuery);


const mapDataToProps = withProps((props) => {
  const { document } = props.data;
  return {
    document,
  };
});


const enhance = compose(
  queryData,
  queryMetaHandler,
  mapDataToProps,
  omitProps('data'),
);

export default enhance;
